import api from "./axios";
import { apiPaths } from "./paths";
import type { User } from "@/types";

const apiOrigin = (process.env.API_URL || "").replace(/\/$/, "");

export const getGoogleAuthUrl = () =>
  `${apiOrigin}/api${apiPaths.auth.google()}`;

export const getMe = () =>
  api.get<User>(apiPaths.users.me()).then((r) => r.data);

export const logout = () =>
  api.post<{ message: string }>(apiPaths.auth.logout()).then((r) => r.data);
